export default "__VITE_ASSET__iM2huVPE__"